import React, { Component, useEffect, useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next'
import OnlineShopView from './OnlineShopView';
import crmServices from '../../wsclient/crmservices'
import { domainName, portal_config } from '../../../portal.config';
import FilterView from './FilterView';
import { sortCartByProductName } from '../../utils/common';

const styles = theme => ({

});

function OnlineShope(props){
    const [active, setActive] = useState('main');
    const [stores, setStores] = useState([]);
    const [paging, setPaging] = useState(null);
    const [showLoading, onShowLoading] = useState(false)
    const [offerItem, setOfferItem] = useState({});
    const [filter_options, setFilterOptions] = useState(null);
    const [filter_options_org, setFilterOptionsOrg] = useState({
        industries: [],
        industry_sectors: []
        });
    const [filterSelected, setFilterSelected] = useState({
        industry: [{ id: "All", name: "All" }],
        industry_sector: [{ id: "All", name: "All" }],
        tag: [{ id: "All", name: "All" }],
        town_city: [{ id: "All", name: "All" }],
        });
    const [openFilter, setOpenFilter] = useState(false);
    const [showOfferDetai, setShowOfferDetail] = useState(false);
    const [hasMore, setHasMore] = useState(true);
    const [showLoadMore, onShowLoadMore] = useState(false);
    const [params, setParams] = useState({
        custom_fields: 'is_shopping_site;true',
        include_custom_fields: true,
        size: 10,
    });
    const [isSelectedFilter, setIsSelectedFilter] = useState(null);
    const [storeSelected, setStoreSelected] = useState(null);

    useEffect(()=>{
        init();
    },[]);

    const init = async()=>{
        await getStores({...params});
        if(portal_config[domainName].isOfferFilter){
            await getIndustries();
            await getIndustrySectors();
        }   
    }
    const handleLoadMore = async() => {
        var params = {...paging}
        params.page = params.page + 1
        params.size = 10
        try{
            onShowLoadMore(true);
            try {
                await getStores(params);
            } catch (error) {
                console.log("load offer exception:", error);
            }
            onShowLoadMore(false);
        }catch(error){
            console.log("Offers Load More Exception:",error);
        }
    }
    const getIndustries = async () =>{
        // var filter_options = {...filter_options_org}
        var filter_options = filter_options_org;
        var content = [];
        onShowLoading(true);
        try {
            var result = await crmServices.config.getIndustries();
            //console.log('getIndustries result=', result)
            if (result.code == 'OK') {
                content = result.data && result.data.content ? result.data.content : [];
                filter_options.industries = content.sort(sortCartByProductName);
            }
        } catch (error) {
            console.log("get industries error:", error);
        }
        await setFilterOptionsOrg(filter_options);
        onShowLoading(false);
    }
    const getIndustrySectors = async() =>{
        onShowLoading(true);
        var content = [];
        try {
            var result = await crmServices.config.getIndustrySectors();
            if (result.code == 'OK') {
                content = result.data && result.data.content ? result.data.content:[];
                // var filter_options = {...filter_options_org}
                var filter_options = filter_options_org;
                filter_options.industry_sectors = content.sort(sortCartByProductName)
                //console.log('getIndustrySectors filter_options=======',filter_options)
                setFilterOptionsOrg(filter_options);
            }
        } catch (error) {
            console.log("get industries error:", error);
        }
        onShowLoading(false);
    }

    const getTags = async (new_filter_options, _filterSelected) => {
        var content = [];
        try {
            var params = {};
            params = getFilterParamByType("industry", "industry", params, _filterSelected);
            params = getFilterParamByType("industry_sector", "industry_sector", params, _filterSelected);
            if (params.industry || params.industry_sector) {
                var result = await crmServices.config.getOrganisationTags(params);
                if (result.code == 'OK') {
                    content = result.data && result.data.content ? result.data.content : [];
                }
            }
        } catch (error) {
            console.log("get industries error:", error);
        }
        var temp_filter_options = new_filter_options;
        if(content.length > 0){ 
            temp_filter_options.tags = [{ id: "All", name: "All" },...content.sort(sortCartByProductName)];
        }else{
            temp_filter_options.tags = [{ id: "All", name: "All" }];
        }
        console.log("AA temp_filter_options:",temp_filter_options);
        setFilterOptions(temp_filter_options);
        return temp_filter_options;
    }
    
    const onSelectFilter = async(type, value) =>{
        var new_filter_options = {...filter_options};
        var newFilterSelected = {...filterSelected};
        var industry_sectors = filter_options_org.industry_sectors;
        if (value.id === 'All') {
            newFilterSelected[type] = [{ id: "All", name: "All" }];
            if (type === 'industry') {
                var filterSector = [];
                //if (industry_sectors && industry_sectors[0] && industry_sectors[0].id != 'All') {
                    industry_sectors = [{ id: "All", name: "All" }, ...industry_sectors];
                //}
                filterSector = industry_sectors
                newFilterSelected.industry_sector = [{ id: "All", name: "All" }];
                newFilterSelected.tag = [{ id: "All", name: "All" }];

                new_filter_options.industry_sectors = filterSector;
            }
        }
        else {
            if (newFilterSelected[type].length == 1 && newFilterSelected[type][0].id == 'All') {
                newFilterSelected[type].splice(0, 1);
            }
            let index = -1;
            for (var i = 0; i < newFilterSelected[type].length; i++) {
                if (newFilterSelected[type][i].id === value.id) {
                    index = i;
                    break;
                }
            }
            if (index >= 0) {
                // newFilterSelected[type].splice(index, 1);
                let industrySelectedIndex = newFilterSelected[type][index];
                newFilterSelected[type].splice(index, 1);
                if(type=='industry'){
                    var industrySectorsSelected = newFilterSelected.industry_sector;
                    industrySectorsSelected.forEach(element => {
                        let related_industries = element.related_industries;
                        let exist = related_industries && related_industries.filter(e => {
                            return e.id == industrySelectedIndex.id;
                        })
                        if(exist && exist.length > 0){
                            industrySectorsSelected = industrySectorsSelected.filter(sector => {
                                return sector.id != element.id
                            })
                        }
                    });
                    newFilterSelected.industry_sector = industrySectorsSelected;
                }
            }
            else {
                newFilterSelected[type].push(value);
            }
            if (type == 'industry') {
                var filterSector = [];
                var industrySelected = newFilterSelected.industry;
                industrySelected.forEach(industry => {
                    industry_sectors.forEach(sector => {
                        var related_industries = sector.related_industries;
                        var itemExist = related_industries && related_industries.filter(i => {
                            return i.id == industry.id
                        })
                        if (itemExist && itemExist.length > 0) {
                            filterSector.push(sector);
                        }
                    })
                })
                new_filter_options.industry_sectors = [{ id: "All", name: "All" }, ...filterSector];
            }
            if (newFilterSelected[type].length == 0) {
                newFilterSelected[type] = [{ id: "All", name: "All" }]
                filterSector = [{ id: "All", name: "All" }, ...industry_sectors];

                new_filter_options.industry_sectors = filterSector;
                if (type == 'industry_sector') {
                    var filterSector = [];
                    var industrySelected = newFilterSelected.industry;
                    industrySelected.forEach(industry => {
                        industry_sectors.forEach(sector => {
                            var related_industries = sector.related_industries;
                            var itemExist = related_industries && related_industries.filter(i => {
                                return i.id == industry.id
                            })
                            if (itemExist && itemExist.length > 0) {
                                filterSector.push(sector);
                            }
                        })
                    })
                    new_filter_options.industry_sectors = [{ id: "All", name: "All" }, ...filterSector];
                }
            }
        }

        if (type == 'industry_sector') {
            newFilterSelected.tag = [{ id: "All", name: "All" }];
        }
        console.log("newFilterSelected44444:", newFilterSelected)
        console.log("new_filter_options4444:", new_filter_options)
        new_filter_options = await getTags(new_filter_options, newFilterSelected);
        setFilterOptions(new_filter_options);
        setFilterSelected(newFilterSelected);
        setIsSelectedFilter(true);
    }
    const onFilter = async() =>{
        onShowLoading(true);
        var new_params = { ...params }
        new_params = getFilterParamByType("industry", "industries", new_params);
        new_params = getFilterParamByType("industry_sector", "industry_sectors", new_params);
        new_params = getFilterParamByType("tag", "organisation_tags", new_params);
        new_params = getFilterParamByType("town_city", "town_cities", new_params);
        console.log("new_params onFilters===", new_params);
        await getStores(new_params);
        onShowLoading(false);
        setParams(new_params);
    }
    const getFilterParamByType = (selectedType, paramType, new_params, _filterSelectedList) =>{
        if(!_filterSelectedList){
            _filterSelectedList = filterSelected;
        }
        var newFilterSelected = _filterSelectedList[selectedType];
        if (newFilterSelected.length > 0 && newFilterSelected[0].id != 'All') {
            new_params[paramType] = "";
            for (var i = 0; i < newFilterSelected.length; i++) {
                if (i == newFilterSelected.length - 1) {
                    new_params[paramType] = new_params[paramType] + newFilterSelected[i].id;
                } else {
                    new_params[paramType] = new_params[paramType] + newFilterSelected[i].id + ",";
                }
            }
        }
        else {
            delete new_params[paramType]
        }
        return new_params;
    }
    const onOpenFilter = async() =>{
        var filter_options = { ...filter_options_org };
        filter_options.industries = [{ id: "All", name: "All" }, ...filter_options.industries];
        filter_options.industry_sectors = [{ id: "All", name: "All" }, ...filter_options.industry_sectors];
        filter_options.tags=[{id: "All", name: "All"}];
        filter_options.town_city = [{id: "All", name: "All"}];
       // var filter_options_org = filter_options;
        var industrySelected = filterSelected.industry;
        if (industrySelected.length > 0 && industrySelected[0].id != 'All') {
            var industry_sectors = filter_options.industry_sectors;
            var filterSector = [];
            industrySelected.forEach(industry => {
                industry_sectors.forEach(sector => {
                    var related_industries = sector.related_industries;
                    if (related_industries) {
                        var itemExist = related_industries && related_industries.filter(i => {
                            return i.id == industry.id
                        })
                        if (itemExist && itemExist.length > 0) {
                            filterSector.push(sector);
                        }
                    }
                })
            })
            filter_options.industry_sectors = [{ id: "All", name: "All" }, ...filterSector];
        }
        setOpenFilter(true);
        setFilterOptions(filter_options)
        setIsSelectedFilter(false);
        await getTags(filter_options);
    }
    const onCloseFilter = () =>{
        if(isSelectedFilter){
            onFilter();
        }

        setOpenFilter(false);
    }
    
    const getStores = async(params) => {
        onShowLoading(true);
        try {
            console.log("Params get locations: ", params);
            var result = await crmServices.rewards.getOrgLocations({ ...params});
            if (result.code == 'OK') {
                console.log("Data locations get stores: ", result.data);
                var merchants = result.data && result.data.content ? result.data.content : [];
                //paging
                var page = paging;
                var newMerchants = [];
                if ((page && page === result.data.paging.page && result.data.paging.page === 1) || 
                result.data.paging.page === 1 || stores.length === 0)
                    newMerchants = result.data.content;
                else if (page === result.data.paging.page && result.data.paging.page > 1) {
                    if (merchants.content.length == result.data.content.length) {
                        newMerchants = stores.concat(merchants);
                    } else {
                        newMerchants = stores;
                    }
                } else {
                    newMerchants = stores.concat(merchants);
                }
                setStores(newMerchants);
                setPaging(result.data.paging);
            }
        } catch (error) {
            console.log("load merchants exception:", error);
        }
        onShowLoading(false);
    }

    const onShowDetail = (store) =>{
        console.log("store=====", store);
        let custom_fields = store.custom_fields;
        let bookingSite = custom_fields ? custom_fields.filter(field =>{
            return field.key == 'booking_site';
        }) : null;
        if(bookingSite && bookingSite.length > 0){ 
            window.open(bookingSite[0].value, "_blank");
        }
    }

    return (
        <div>
            {/* <Loading showLoading={showLoading} /> */}
            <OnlineShopView
                stores={stores}
                showLoading={showLoading}
                filter_options={filter_options}
                onSelectFilter = {onSelectFilter}
                filterSelected= {filterSelected}
                handleLoadMore = {handleLoadMore}
                hasMore = {hasMore}
                showLoadMore = {showLoadMore}
                onOpenFilter={onOpenFilter}
                onShowDetail={onShowDetail}
                />
            {openFilter && <FilterView open={openFilter}
                showLoading={showLoading}
                onClose={onCloseFilter}
                filter_options={filter_options}
                filterSelected={filterSelected}
                onSelectFilter={onSelectFilter}
                onApplyFilter = {onCloseFilter}/>}    
        </div>
    );
}

export default withStyles(styles)(withTranslation()(OnlineShope));